// extracted by mini-css-extract-plugin
export default {"rich-text-editor":"R1gW48"};